{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "حدد عنصرًا",
  "tableResizer": "أداة تغيير الحجم",
  "colorSwatchPicker": "Color swatches"
}
